"use client";
import {
  ChartConfig,
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { Item, ItemTitle } from "@/components/ui/item";
import { UI } from "@/constants";
import { formatDate, numberUsLocale } from "@/lib";
import { OrderType } from "@/types";
import { CartesianGrid, Line, LineChart, XAxis, YAxis } from "recharts";

const chartConfig = {
  sharedProductsTotal: {
    label: UI.labels.sharedProductsTotal,
    color: "var(--chart-4)",
  },
  productsTotal: {
    label: UI.labels.productsTotal,
    color: "var(--success)",
  },
} satisfies ChartConfig;

type ProductOrdersChartProps = {
  orders: OrderType[];
};

export const ProductOrdersChart = ({ orders }: ProductOrdersChartProps) => {
  if (!orders?.length) return null;

  return (
    <Item variant="outline">
      <ItemTitle>{UI.titles.productOrdersChart}</ItemTitle>
      <ChartContainer config={chartConfig} className="chart-container">
        <LineChart accessibilityLayer data={orders}>
          <CartesianGrid vertical={false} />
          <YAxis
            type="number"
            tickMargin={8}
            padding={{ bottom: 16 }}
            tickFormatter={value => numberUsLocale(Number(value))}
          />
          <XAxis
            dataKey="deliveryDate"
            tickMargin={8}
            minTickGap={16}
            padding={{ left: 16, right: 40 }}
            reversed
            tickFormatter={value => formatDate(value)}
          />
          <ChartTooltip
            content={
              <ChartTooltipContent className="w-52" labelFormatter={value => formatDate(value)} />
            }
          />
          <ChartLegend content={<ChartLegendContent />} />
          <Line
            dataKey="sharedProductsTotal"
            type="linear"
            stroke="var(--color-sharedProductsTotal)"
            strokeWidth={2}
            activeDot={{ r: 4 }}
          />
          <Line
            dataKey="productsTotal"
            type="linear"
            stroke="var(--color-productsTotal)"
            strokeWidth={2}
            activeDot={{ r: 4 }}
          />
        </LineChart>
      </ChartContainer>
    </Item>
  );
};
